export function hasPremiumAccess(paymentDetails: any): boolean {
  if (!paymentDetails) return false;

  const { status, trial_end } = paymentDetails;

  const isActive = status === 1;
  const isInTrial = trial_end && new Date(trial_end) > new Date();

  return isActive || isInTrial;
}